<template>
  <Menu.Root>
    <Menu.Trigger>
      <button
        type="button"
        class="flex shrink-0 select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm font-medium text-gray-700 outline-2 outline-blue-500 transition hover:bg-gray-200 focus-visible:outline data-[state=open]:bg-card dark:text-white dark:hover:bg-card"
      >
        <HelpIcon
          class="size-4 text-gray-500 transition dark:text-muted-foreground"
        />
        <span>Get help</span>
      </button>
    </Menu.Trigger>

    <Menu.Container>
      <Menu.SectionHeader>Resources</Menu.SectionHeader>
      <Menu.LinkItem
        label="Documentation"
        icon="book-open"
        href="https://docs.buttondown.com"
      />

      <Menu.LinkItem
        label="Changelog"
        icon="newsletter"
        href="https://buttondown.com/changelog"
      />
      <Menu.LinkItem
        label="Contact support"
        icon="envelope"
        href="mailto:support@buttondown.com"
      />

      <Menu.SectionHeader>Stay in touch</Menu.SectionHeader>

      <Menu.LinkItem
        label="Bluesky"
        icon="brand-bluesky"
        href="https://bsky.app/profile/buttondown.com"
      />

      <Menu.LinkItem
        label="Mastodon"
        icon="brand-mastodon"
        href="https://mastodon.social/@buttondown"
      />

      <Menu.LinkItem
        label="Twitter"
        icon="brand-twitter"
        href="https://x.com/buttondown"
      />

      <Menu.Divider />

      <Menu.Submenu label="Application theme">
        <Menu.CheckboxItem
          :model-value="theme === 'auto'"
          label="System"
          @update:model-value="theme = 'auto'"
        />

        <Menu.CheckboxItem
          :model-value="theme === 'light'"
          label="Light"
          @update:model-value="theme = 'light'"
        />

        <Menu.CheckboxItem
          :model-value="theme === 'dark'"
          label="Dark (beta)"
          @update:model-value="theme = 'dark'"
        />
      </Menu.Submenu>
    </Menu.Container>
  </Menu.Root>
</template>

<script setup lang="ts">
import { toRef } from "vue";

import Menu from "@/design_system/Menu";
import HelpIcon from "@/icons/heroicons/question-mark-circle-micro.svg";
import { useStore as useUiStatesStore } from "@/store/stores/ui-states";

const uiStates = useUiStatesStore();
const theme = toRef(uiStates, "appTheme");
</script>
